<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import './styles/design-system.scss';
@import './styles/global.scss';

body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Fira Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $text-primary;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background-color: $bg-color;
}

:root {
  --el-color-primary: #3B82F6;
  --el-color-primary-light: #60A5FA;
  --el-color-primary-dark: #2563EB;
  --el-color-success: #10B981;
  --el-color-warning: #F59E0B;
  --el-color-danger: #EF4444;
  --el-color-info: #0EA5E9;
}

.el-button--primary {
  background: linear-gradient(135deg, #3B82F6 0%, #60A5FA 100%);
  border: none;

  &:hover {
    background: linear-gradient(135deg, #60A5FA 0%, #93C5FD 100%);
  }
  
  &:active {
    transform: scale(0.98);
  }
}

.el-button--danger {
  background: linear-gradient(135deg, #EF4444 0%, #DC2626 100%);
  border: none;
}

.el-input__inner {
  border-radius: 8px;
  border-color: #EBEEF5;
  
  &::placeholder {
    color: #909399;
    font-weight: normal;
  }
  
  &:focus {
    border-color: #2B7FF0;
    box-shadow: 0 0 0 4px rgba(43, 127, 240, 0.1);
  }
}
.el-select .el-input__inner::placeholder {
  color: #909399;
}

.el-card {
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: none;
}

.el-table {
  --el-table-header-text-color: #666666;
  --el-table-row-hover-bg-color: #F5F7FA;
  
  .el-table__header {
    background: #F8F9FA;
    
    th {
      border-bottom: 2px solid #EBEEF5;
      font-weight: 600;
    }
  }
  
  .el-table__body {
    tr {
      transition: background 0.2s ease;
    }
  }
}

.el-pagination {
  .el-pager li {
    border-radius: 8px;
    
    &.active {
      background: linear-gradient(135deg, #2B7FF0 0%, #4A9FFF 100%);
      color: #fff;
      border-color: transparent;
    }
  }
}

.el-dialog {
  border-radius: 16px;
  overflow: hidden;
  
  .el-dialog__header {
    background: linear-gradient(135deg, #2B7FF0 0%, #4A9FFF 100%);
    padding: 20px 24px;
    
    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }
    
    .el-dialog__close {
      color: rgba(255, 255, 255, 0.8);
      
      &:hover {
        color: #fff;
      }
    }
  }
}

.el-select {
  .el-input__inner {
    cursor: pointer;
  }
}

// ==================== 侧栏菜单全局覆盖 ====================
.sidebar-menu .el-menu {
  padding: 0 !important;
}
.sidebar-menu .el-menu--inline {
  padding: 0 !important;
}
.sidebar-menu .el-scrollbar__view {
  padding: 0 !important;
}
.sidebar-menu .el-menu-item,
.sidebar-menu .el-submenu__title {
  height: 44px !important;
  line-height: 44px !important;
}
.sidebar-menu .nav-menu > .el-menu-item,
.sidebar-menu .nav-menu > .el-submenu > .el-submenu__title {
  padding-left: 8px !important;
  font-weight: 700 !important;
  font-size: 15px !important;
}
.sidebar-menu .nav-menu > .el-submenu > .el-menu > .el-menu-item,
.sidebar-menu .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-submenu__title {
  padding-left: 20px !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}
.sidebar-menu .nav-menu > .el-submenu > .el-menu > .el-submenu > .el-menu > .el-menu-item {
  padding-left: 36px !important;
  font-weight: 400 !important;
  font-size: 13px !important;
}

.el-date-editor {
  width: 100%;
}

.margin-0 { margin: 0; }
.margin-lr-0 { margin-left: 0; margin-right: 0; }
.margin-xs { margin: 5px; }
.margin-sm { margin: 10px; }
.margin { margin: 15px; }
.margin-lg { margin: 20px; }
.margin-xl { margin: 25px; }
.margin-top-xs { margin-top: 5px; }
.margin-top-sm { margin-top: 10px; }
.margin-top { margin-top: 15px; }
.margin-top-lg { margin-top: 20px; }
.margin-top-xl { margin-top: 25px; }
.margin-right-xs { margin-right: 5px; }
.margin-right-sm { margin-right: 10px; }
.margin-right { margin-right: 15px; }
.margin-right-lg { margin-right: 20px; }
.margin-right-xl { margin-right: 25px; }
.margin-bottom-0 { margin-bottom: 0; }
.margin-bottom-xs { margin-bottom: 5px; }
.margin-bottom-sm { margin-bottom: 10px; }
.margin-bottom { margin-bottom: 15px; }
.margin-bottom-lg { margin-bottom: 20px; }
.margin-bottom-xl { margin-bottom: 25px; }
.margin-left-0 { margin-left: 0; }
.margin-left-xs { margin-left: 5px; }
.margin-left-sm { margin-left: 10px; }
.margin-left { margin-left: 15px; }
.margin-left-lg { margin-left: 20px; }
.margin-lr-xs { margin-left: 5px; margin-right: 10px; }
.margin-lr-sm { margin-left: 10px; margin-right: 10px; }
.margin-lr { margin-left: 15px; margin-right: 15px; }
.margin-lr-lg { margin-left: 20px; margin-right: 20px; }
.margin-tb-xs { margin-top: 5px; margin-bottom: 5px; }
.margin-tb-sm { margin-top: 10px; margin-bottom: 10px; }
.margin-tb { margin-top: 15px; margin-bottom: 15px; }
.margin-tb-lg { margin-top: 20px; margin-bottom: 20px; }
.padding-0 { padding: 0; }
.padding-lr-0 { padding-left: 0; padding-right: 0; }
.padding-xs { padding: 5px; }
.padding-sm { padding: 10px; }
.padding { padding: 15px; }
.padding-lg { padding: 20px; }
.padding-xl { padding: 25px; }
.padding-top-xs { padding-top: 5px; }
.padding-top-sm { padding-top: 10px; }
.padding-top { padding-top: 15px; }
.padding-top-lg { padding-top: 20px; }
.padding-right-xs { padding-right: 5px; }
.padding-right-sm { padding-right: 10px; }
.padding-right { padding-right: 15px; }
.padding-bottom-xs { padding-bottom: 5px; }
.padding-bottom-sm { padding-bottom: 10px; }
.padding-bottom { padding-bottom: 15px; }
.padding-left-xs { padding-left: 5px; }
.padding-left-sm { padding-left: 10px; }
.padding-left { padding-left: 15px; }
.padding-lr-xs { padding-left: 5px; padding-right: 5px; }
.padding-lr-sm { padding-left: 10px; padding-right: 10px; }
.padding-lr { padding-left: 15px; padding-right: 15px; }
.padding-tb-xs { padding-top: 5px; padding-bottom: 5px; }
.padding-tb-sm { padding-top: 10px; padding-bottom: 10px; }
.padding-tb { padding-top: 15px; padding-bottom: 15px; }
.flex { display: flex; }
.flex-direction { flex-direction: column; }
.flex-wrap { flex-wrap: wrap; }
.justify-start { justify-content: flex-start; }
.justify-end { justify-content: flex-end; }
.justify-center { justify-content: center; }
.justify-between { justify-content: space-between; }
.justify-around { justify-content: space-around; }
.text-center { text-align: center; }
.white-bg { background-color: #fff; }
.bg-white { background-color: #fff; }
.ibox { clear: both; margin-bottom: 5px; margin-top: 0; padding: 0; }
.ibox .ibox-title { border-top-left-radius: 10px; border-top-right-radius: 10px; text-align: left; }
.ibox-title { background-color: #fff; border-color: #EBEEF5; border-style: solid solid none; border-width: 2px 0 0; color: inherit; margin-bottom: 0; padding: 15px; position: relative; clear: both; }
.ibox-title h5 { display: inline-block; font-size: 14px; margin: 0 0 7px; padding: 0; text-overflow: ellipsis; float: none; }
.border-radius { border-radius: 10px; }
.text-right { text-align: right; }
.text-left { text-align: left; }
ul { padding-inline-start: 0; }
ul li { list-style-type: none; }
h2 { font-size: 24px; }
h1, h2, h3 { margin-top: 20px; margin-bottom: 10px; }
h1, h2, h3, h4, h5, h6 { font-weight: 600; }
h3 { font-size: 16px; }
.el-select { width: 100%; }
.el-date-editor { width: 100%; }
.list-group-border-radius { border-radius: 8px; border: 1px solid #EBEEF5; background: #fff; }
.list-group { list-style: none; padding: 0; margin: 0; }
.list-group-item { padding: 12px 15px; cursor: pointer; }
.list-group-item:hover { background-color: #F5F7FA; }
.vc-node-selected { background-color: #2B7FF0; color: #fff; font-weight: bold; }
.vc-node-selected:hover { background-color: #2B7FF0; }
.table-desc { text-align: left; font-size: 13px; color: #606266; }
</style>